import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {StorageService} from "@cybfed/core/services/storage.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {TopupComponentNewComponent} from "@cybfed/shared/components/topup-component-new/topup-component-new.component";
import markAllControlsAsTouched from "@cybfed/core/helpers/mark-all-controls-as-touched";
import {PopupHelperService} from "@cybfed/core/services/popup-helper.service";
import {OrderService} from "@cybfed/core/services/marketplace/order.service";
import {EventManagerService} from "@cybfed/core/services/event-manager.service";
import {CurrencyPipe} from "@cybfed/shared/pipes/currency.pipe";
import {ToggleComponent} from "@white-label/components/white-label/toggle/toggle.component";

@Component({
    selector: 'app-donation-widget-form',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        TopupComponentNewComponent,
        CurrencyPipe,
        ToggleComponent,
    ],
    providers: [],
    templateUrl: './donation-widget-form.component.html'
})
export class DonationWidgetFormComponent implements OnInit {
    @Output() nextStep: EventEmitter<any> = new EventEmitter();
    @Output() prevStep: EventEmitter<any> = new EventEmitter();

    // @Input({required: true}) product: any;
    @Input({required: true}) services!: any[];
    @Input() form!: FormGroup; // Reactive form group

    currentUser: any
    selectedPaymentMethode: any = 'paymentGateway'
    paymentLoading: boolean = false
    public paymentData: any = {
        amount: 0,
        currency: '',
        ticket: 0,
        topic: 'money',
        _id: '',
        serviceCount: 1
    }

    public amount!: number


    constructor(public mainStore: MainStoreService,
                private fb: FormBuilder,
                private cdr: ChangeDetectorRef,
                private popupHelperService: PopupHelperService,
                private orderService: OrderService,
                private eventManagerService: EventManagerService,) {
    }

    ngOnInit() {
        this.currentUser = StorageService.getJsonItem(StorageService.statics.currentUser);
        this.paymentData.ticket = 0
        this.paymentData.currency = this.form.get('currency')?.value;
        this.paymentData.amount = (Number(this.form.get('price')?.value)| 0) +  (Number(this.form.get('tip')?.value)| 0);
        this.amount = this.paymentData.amount;
    }


    async donate() {
        if (this.form.valid) {
            this.paymentData.amount = this.amount;
            let tip = (this.amount - (Number(this.form.get('price')?.value)| 0))
            // if (this.product.accountId?._id !== this.currentUser?.userId) {
                if (this.selectedPaymentMethode === 'stripe' || this.selectedPaymentMethode === 'paymentGateway') {
                    this.paymentData = {
                        ...this.paymentData,
                        productServices: this.services,
                        email: this.form.value.email,
                        productType: "donation",
                        tip: tip,
                        // serviceCount: this.form.value.count,
                        // requiredFields: this.objectToArray(this.form.value.requiredFields),
                        // productId: this.product._id,
                        // productServiceId: this.selectedItem._id,
                        metadata: this.form.value.metaData,
                    }
                    this.cdr.detectChanges()
                    this.eventManagerService.makePaymentTopupNewComponent.emit({
                        paymentMethod: this.selectedPaymentMethode
                    })
                } else if (this.selectedPaymentMethode === 'balance') {
                    await this.buyFromBalance()
                }
            // } else {
            //     this.popupHelperService.printError({
            //         text: 'you_cant_buy_from_yourself'
            //     })
            // }


            // this.nextStep.emit(this.form.value); // Emit form values on success
        } else {
            markAllControlsAsTouched(this.form);
        }
        this.cdr.detectChanges()
    }

    changePaymentMethode(paymentMethod: any) {
        this.selectedPaymentMethode = paymentMethod;
        if (paymentMethod === 'ticketBalance') {
            // this.selectedItem.topic = 'ticket'
        } else {
            // this.selectedItem.topic = 'money'
        }
    }

    finishPayment(data: any) {
        this.nextStep.emit({
            orderId: data.orderId,
        });
    }

    paymentLoadingTrigger(loading: boolean) {
        this.paymentLoading = loading
    }

    objectToArray(obj: Record<string, string>): { key: string; value: string }[] {
        return Object.entries(obj).map(([key, value]) => ({key, value}));
    }

    buyFromBalance() {
        let formdata = this.formatForSendToBackend()
        this.paymentLoading = true
        this.orderService.buyMany(formdata).subscribe((data) => {
            if (!data.hasError) {
                this.nextStep.emit({
                    type: 'finishDonate',
                });
            } else {
                this.popupHelperService.printError({text: data.errorMessages[0].msg})
            }
            this.paymentLoading = false
        })
    }

    formatForSendToBackend() {
        return {
            serviceCount: this.form.value.count,
            currency: this.form.value.currency,
            requiredFields: this.objectToArray(this.form.value.requiredFields),
            email: this.form.value.email,
            productServices: this.services,
            paymentType: this.selectedPaymentMethode,
            metaData: this.form.value.metaData,
            tip: this.form.get('tip')?.value,
            productType: "donation",
        }
    }

    protected readonly Math = Math;

    coveringServiceFee(event: Event) {
        let sellerFee: number = this.mainStore.publisher.sellerFee || 0
        if (event) {
            this.amount = (this.paymentData.amount * 100) / (100-sellerFee)
        }else{
            this.amount = this.paymentData.amount
        }
        console.log(this.mainStore.publisher)
    }
}
